import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'UnitHistory.header',
    defaultMessage: 'Unit History',
  },
  floorPlanColumn: {
    id: 'UnitHistory.floorPlanColumn',
    defaultMessage: 'Floor Plan',
  },
  setAsideColumn: {
    id: 'UnitHistory.setAsideColumn',
    defaultMessage: 'Set Aside',
  },
  startDateColumn: {
    id: 'UnitHistory.startDateColumn',
    defaultMessage: 'Start Date',
  },
  endDateColumn: {
    id: 'UnitHistory.endDateColumn',
    defaultMessage: 'End Date',
  },
  changedByColumn: {
    id: 'UnitHistory.changedByColumn',
    defaultMessage: 'Changed By',
  },
  emptyStateMessage: {
    id: 'UnitHistory.emptyStateMessage',
    defaultMessage: 'No data available.',
  },
  residentHistory: {
    id: 'UnitHistory.residentHistory',
    defaultMessage: 'Resident History',
  },
  priorResident: {
    id: 'UnitHistory.priorResident',
    defaultMessage: 'Prior Resident',
  },
  moveInDate: {
    id: 'UnitHistory.moveInDate',
    defaultMessage: 'Move-In Date',
  },
  moveOutDate: {
    id: 'UnitHistory.moveOutDate',
    defaultMessage: 'Move-Out Date',
  },
  transfer: {
    id: 'UnitHistory.transfer',
    defaultMessage: 'Transfer',
  },
  floorPlanAtMoveOut: {
    id: 'UnitHistory.floorPlanAtMoveOut',
    defaultMessage: 'Floor Plan at Move-Out',
  },
});

export default messages;
